var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f1b7838fe74c170f7958080825db3f7f400109b2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@eprezto"]={id:"f1b7838fe74c170f7958080825db3f7f400109b2"};
      